import { PropertyFinancial } from './../../../property/shared/models/property-financial';
import {
  Component,
  OnInit,
  Input,  
  OnChanges
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CustomValidators } from '../../../../shared/validators';
import { InformationSource } from '../../../component/models';
import { SetupFiscalYearRequest } from '../../shared/models';

@Component({
  selector: 'sp-setup-component-aging',
  templateUrl: './setup-component-aging.component.html',
  styleUrls: ['./setup-component-aging.component.scss'],
  standalone: false
})
export class SetupComponentAgingComponent implements OnInit, OnChanges {

  @Input() propertyFinancial: PropertyFinancial;
  @Input() informationSources: InformationSource[];

  formGroup: UntypedFormGroup = new UntypedFormGroup({});

  constructor(private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.initForm();
  }

  ngOnChanges(): void {
    this.initForm();
  }

  getFinancialDetails() {
    const financialDetail = new SetupFiscalYearRequest();
    financialDetail.inflationRate = this.formGroup.controls['inflationRate'].value;
    financialDetail.informationSourceId = this.formGroup.controls['informationSourceYesNo'].value === true
      ? this.formGroup.controls['informationSourceId'].value
      : null;

    return financialDetail;
  }

  private initForm() {
    this.formGroup = this.fb.group({
      'inflationRate': this.fb.control(this.propertyFinancial ? this.propertyFinancial.inflationRate : 0,
        [Validators.required, CustomValidators.rangeValidator(0, 20)]), // hidden
      'informationSourceYesNo': this.fb.control(false),
      'informationSourceId': this.fb.control(13, [Validators.required]), // hidden
    });
  }
}
